// extracted by mini-css-extract-plugin
export default {"container":"AssetWithShimmer_container__IBwCL","shimmer":"AssetWithShimmer_shimmer__BCO7M"};